import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import InterestedInUsedGMC from './InterestedInUsedGMC';

const Used2015MercedesBenzC300Sport4maticSedanForSaleInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale In Boerne & Austin, Texas at Mark Motors"
                description="The used 2015 Mercedes-Benz 300 Sport 4MATIC Sedan for sale in Boerne & Austin, Texas showcases another option to its family of trims - C300, C300 Sport, and C300 Luxury - that is packed with class, elegance, and the power that you have been looking for."
                keywords="2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne & Austin, Texas | 2015 Mercedes-Benz C300 Sport 4MATIC Sedan Specials in Boerne & Austin, Texas | 2015 Mercedes-Benz C300 Sport 4MATIC Sedan Dealer in Boerne & Austin, Texas | 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale Near Boerne & Austin, Texas | 2015 Mercedes-Benz C300 Sport 4MATIC Sedan in Boerne & Austin TX"
                ogTitle="Used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale In Boerne & Austin, Texas at Mark Motors"
                ogDescription="The used 2015 Mercedes-Benz 300 Sport 4MATIC Sedan for sale in Boerne & Austin, Texas showcases another option to its family of trims - C300, C300 Sport, and C300 Luxury - that is packed with class, elegance, and the power that you have been looking for."
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <h1><span className="s1"><strong>Used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale In Boerne, Texas at Mark Motors</strong></span></h1>
                        <p><span>The used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan for sale in Boerne, Texas at Mark Motors takes an exceptional base model in its family and enhances it with a touch of sportiness and the highly recognized 4MATIC, the All-Wheel Drive System developed by Mercedes. The used 2015 Mercedes-Benz 300 Sport 4MATIC Sedan showcases another option to its family of trims - C300, C300 Sport, and C300 Luxury - that is packed with class, elegance, and the power that you have been looking for. The used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan for sale in Boerne, Texas comes in a variety of elegant, bold colors such as Black, Polar White, Diamond Silver Metallic, Dakota Brown Metallic, Iridium Silver Metallic, Lunar Blue Metallic, Obsidian Black Metallic, Palladium Silver Metallic, and Diamond White Metallic. Take a trip to Mark Motors in Boerne, Texas and let our team of experienced specialists help you find the perfect used 2015 Mercedes-Benz C300 Sport Sedan for sale.</span>
                        </p>

                        <h2><span className="s1"><strong>2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne, Texas at Mark Motors.</strong></span></h2>
                        <p><span>2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne, Texas.</span></p>
                        <h2><span className="s1"><strong>Overview - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Engine</strong></span>
                            <span>2.0 I-4 Engine</span>
                            <span>241 HP @ 5500 rpm</span>
                            <span>273 @ 1300 rpm Torque</span>
                            <span><strong>Transmission</strong></span>
                            <span>7-Speed with/ OD Transmission</span>
                            <span><strong>Drive Type</strong></span>
                            <span>4MATIC All-Wheel Drive</span><span>&nbsp;</span>
                            <span><strong>Wheels</strong></span>
                            <span>18-inch Silver w/ Painted Accents AMG Aluminum Wheels</span>
                            <span><strong>Efficiency</strong></span>
                            <span>24 city / 31 hwy / 27 combined mpg</span>
                        </p>
                        <h2><span className="s1"><strong>Dimensions &amp; Capacity - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale Near Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Wheelbase: 111.8 in.</span>
                            <span>Front Legroom: 41.7 in.</span>
                            <span>Front Headroom: 31.1 in.</span>
                            <span>Maximum Interior Cargo Volume: 12.6 cu. ft.</span>
                            <span>Engine Horsepower: 241-hp @ 5500 rpm.</span>
                            <span>Interior Cargo Volume: 12.6 cu. ft.</span>
                            <span>Passenger Volume: 88.2 cu. ft.</span>
                            <span>Engine Bore x Stroke: 3.3 in. X 3.6 in.</span>
                            <span>Compression Ratio: 9.80 to 1.</span>
                            <span>Engine Type: I-4.</span>
                            <span>Valves: 16.</span>
                            <span>Front Tread: 61.6 in.</span>
                            <span>Ground Clearance (max): 4.1 in.</span>
                            <span>Fuel Economy City: 24 mpg</span>
                            <span>Fuel Economy Highway: 31 mpg.</span>
                            <span>Engine Torque: 273 lbs.-ft. @ 1300 rpm.</span>
                            <span>Exterior Body Width: 71.3 in.</span>
                            <span>Drag Coefficient: .30</span>
                            <span>Turning Radius: 18.4 ft.</span>
                            <span>Rear Headroom: 37.1 in.</span>
                            <span>Rear Shoulder Room: 55 in.</span>
                            <span>Rear Legroom: 35.2 in.</span>
                            <span>Curb Weight: 3594 lbs.</span>
                            <span>Fuel Tank Capacity: 18 gal.</span>
                            <span>Valve Train: DOHC.</span>
                            <span>Engine Displacement: 121 cu. in.</span>
                            <span>Exterior Length: 184.5 in.</span>
                            <span>Exterior Height: 56.8 in.</span>
                            <span>Rear Tread: 60.8 in.</span>
                        </p>
                        <h2><span className="s1"><strong>Interior Features - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan Dealer In Boerne, Texas</strong></span></h2>
                        <p>
                            <span><strong>Convenience</strong></span>
                            <span>Cruise Control</span>
                            <span>Available Distance Pacing Cruise Control.</span>
                            <span>Available Control with DISTRONIC PLUS Distance Pacing.</span>
                            <span>Door Mirror Memory.</span>
                            <span>2 Setback Storage Pockets.</span>
                            <span>Passenger Power Folding Mirror.</span>
                            <span>Power Windows with Front and Rear 1-Touch Down.</span>
                            <span>Emergency Communication System mbrace2.</span>
                            <span>Power Cargo Access Remote Release.</span>
                            <span>Available Sunshade.</span>
                            <span>Integrated Key/Remote.</span>
                            <span>Rear Door Bins.</span>
                            <span>Available Panoramic Sunroof.</span>
                            <span>Air Filter.</span>
                            <span>Day-Night Rearview Mirror.</span>
                            <span>Available Trunk/Hatch Auto-Latch.</span>
                            <span>Homelink Garage Door Transmitter.</span>
                            <span>Keyfob (all doors) Remote Keyless Entry.</span>
                            <span>Available 3 Driver and Passenger Memory Seat Settings (includes door mirrors, steering wheel, head restraints).</span>
                            <span>Full Floor Console.</span>
                            <span>Driver and Passenger Door Bins.</span>
                            <span>Front Dual Zone A/C.</span>
                            <span>Available Navigation System with Voice Activation.</span>
                            <span>Automatic Temperature Control.</span>
                            <span>Retained Accessory Power.</span>
                            <span>Available Navigation System.</span>
                            <span>2 12V DC Power Outlets.</span>
                            <span>Available 1st Row Express Open/Close Sliding and Tilting Glass Sunroof.</span>
                            <span>Rear Cupholders.</span>
                            <span>Proximity Key.</span>
                            <span>Steering Wheel with Power Tilting, Power Telescoping, Auto Tilt-Away.</span>
                            <span>Illuminated Driver and Passenger-Side Visor Mirrors.</span>
                            <span>Remote Window Controls.</span>
                            <span>Available 2nd Row Sunshade.</span>
                            <span>Steering Wheel Memory.</span>
                            <span>3 Memory Settings.</span>
                            <span>Front Lighter Elements Location.</span>
                            <span>Illuminated Entry.</span>
                            <span>Available Power Glass Tilting and Sliding Sunroof.</span>
                            <span>Overhead Console.</span>
                            <span>Ashtray.</span>
                            <span>Illuminated Driver and Passenger Vanity Mirror.</span>
                            <span>Air Conditioning.</span>
                            <span>1-Touch Down.</span>
                            <span>Keyfob/Trunk/Hatch/Door Release.</span>
                            <span>Trunk/Hatch/Door FOB Controls.</span>
                            <span>Front and Rear Cupholders.</span>
                            <span>Remote Keyless Entry.</span>
                            <span>Console Ducts.</span>
                            <span>Available Hands-Free Auto-Opening Trunk/Liftgate.</span>
                            <span>Available Power Sunshade.</span>
                            <span>Full Floor Console with Covered Box.</span>
                            <span>1-Touch Up.</span>
                            <span>Driver’s Footrest.</span>
                            <span>Valet Function.</span>
                            <span>Auto-Locking Doors.</span>
                            <span>Available Power Windows.</span>
                            <span>Automatic Dual-Zone Front Air Conditioning.</span>
                            <span>Mini Overhead Console.</span>
                            <span>Window FOB Controls.</span>
                            <span>Memory Seats.</span>
                            <span>Auto-Dimming Rearview Mirror.</span>
                            <span>Head Restraints Memory.</span>
                            <span>Available Fixed Glass 2nd Row Sunroof.</span>
                            <span>Available Proximity Cargo Access Remote Release.</span>
                            <span>Telescoping Steering Wheel.</span>
                            <span>Driver Power Folding Mirror.</span>
                            <span>Illuminated Glove Box.</span>
                            <span>Illuminated Locking Glove Box.</span>
                            <span>Auto Tilt-Away Steering Wheel.</span>
                            <span>Tilt Steering Wheel.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sport 4MATIC Sedans For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Seats and Trim</strong></span>
                            <span>Rear Seat Armrest Storage.</span>
                            <span>8-Way Power Driver Seat.</span>
                            <span>Available Genuine Wood Instrument Panel Insert.</span>
                            <span>Aluminum Instrument Panel Insert, Door Panel Insert.</span>
                            <span>5 Max Seating Capacity.</span>
                            <span>Rear Seat Fold-Forward Setback.</span>
                            <span>Carpet Front and Rear Floor Mats.</span>
                            <span>Power 4-Way Driver and Passenger Lumbar Support.</span>
                            <span>Available Driver and Passenger Heated-Cushions.</span>
                            <span>Passenger Cushion Tilt.</span>
                            <span>Floor Mats.</span>
                            <span>Metal-Look Interior Accents.</span>
                            <span>Driver Cushion Tilt.</span>
                            <span>Passenger Lumbar Support.</span>
                            <span>Cargo Light.</span>
                            <span>Front Center Armrest.</span>
                            <span>Power Driver and Passenger Fore/Aft Adjustment.</span>
                            <span>Cargo Tie-Downs.</span>
                            <span>Front Bucket Seats.</span>
                            <span>Power Driver and Passenger Cushion Tilt.</span>
                            <span>Genuine Wood Console Insert.</span>
                            <span>Urethane Shift Knob.</span>
                            <span>Available Genuine Wood/Metal-Look Door Panel Insert.</span>
                            <span>Full Cloth Headliner.</span>
                            <span>Carpet Cargo Space.</span>
                            <span>8-Way Power Passenger Seat.</span>
                            <span>Leatherette Upholstery.</span>
                            <span>Bucket Front Seats.</span>
                            <span>Height Adjustable Driver Seat.</span>
                            <span>MB-Tex Leatherette Door Panel Trim.</span>
                            <span>Available Power 4-Way Passenger Lumbar Support.</span>
                            <span>Available Power Height-Adjustable Passenger Seat.</span>
                            <span>MB-Tex Leatherette Front and Rear Seat Upholstery.</span>
                            <span>Drive Lumbar Support.</span>
                            <span>Rear Bench Seat.</span>
                            <span>Available Leather Front and Rear Seat Upholstery.</span>
                            <span>Available Power Reclining Passenger Seat.</span>
                            <span>Carpet Trunk Lild/Rear Cargo Door.</span>
                            <span>Ventilated Front Seats.</span>
                            <span>Rear Seat Center Armrest with Storage.</span>
                            <span>Available Power Passenger Cushion Tilt.</span>
                            <span>Power Reclining Driver and Passenger Seats.</span>
                            <span>Rear Seat Center Armrest.</span>
                            <span>Available Driver and Passenger Heated-Setbacks.</span>
                            <span>Rear 40-20-40 Bench Seat.</span>
                            <span>Carpet Floor Covering.</span>
                            <span>Available Leather Upholstery.</span>
                            <span>Available 8-Way Passenger Seat Adjustment.</span>
                            <span>Max. Seating Capacity of 5.</span>
                            <span>Height Adjustable Passenger Seat.</span>
                            <span>Piano Black Console Insert.</span>
                            <span>Available Power Passenger Fore/Aft Adjustment.</span>
                            <span>8-Way Driver and Passenger Seat Adjustments.</span>
                            <span>Available Genuine Wood Instrument Panel Insert, Console Insert.</span>
                            <span>Power Height-Adjustable Driver and Passenger Seats.</span>
                            <span>Leather/Metal-Look Steering Wheel.</span>
                            <span>Available Heated Front Seats.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sport 4MATIC Sedans For Sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Entertainment Features - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan Dealer In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Steering-Wheel Mounted Audio Controls.</span>
                            <span>Primary Monitor Touchscreen.</span>
                            <span>Available Digital Signal Processor.</span>
                            <span>Window Grid Antenna.</span>
                            <span>2 1st Row LCD Monitors.</span>
                            <span>Send2Benz Internet Access.</span>
                            <span>Available 590W Amplifier.</span>
                            <span>Wireless Phone Connectivity.</span>
                            <span>Available 13 Premium Speakers.</span>
                            <span>Available SiriusXM AM/FM/HD/Satellite with Seek-Scan, Single In-Dash CD Player.</span>
                            <span>Audio Theft Deterrent.</span>
                            <span>CD Player.</span>
                            <span>Radio Data System.</span>
                            <span>Available 13 Burmeister Speakers.</span>
                            <span>AM/FM Radio.</span>
                            <span>8 Speakers.</span>
                            <span>Weather Band Radio.</span>
                            <span>Available Voice Activated Radio.</span>
                            <span>MP3 Decoder.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sport 4MATIC Sedans For Sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Exterior Features - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Black w/ Chrome Accent Grilles.</span>
                            <span>Chrome Tip Exhaust.</span>
                            <span>Power Remote Right Side-View Door Mirror with Tilt Down.</span>
                            <span>Body-Colored Door Handles.</span>
                            <span>Auto Dimming Power Remote Left Side-View Door Mirror.</span>
                            <span>Turn Signal Indicator Mirrors.</span>
                            <span>Heated Door Mirrors.</span>
                            <span>Available Metallic Paint.</span>
                            <span>Galvanized Steel/Aluminum Body Material.</span>
                            <span>Available Remote Trunk Lid Closing System.</span>
                            <span>Power Door Mirrors.</span>
                            <span>4 Doors.</span>
                            <span>Rear Cargo Trunk.</span>
                            <span>Body-Colored Front and Rear Bumpers.</span>
                            <span>Bodyside Moldings.</span>
                            <span>Rear Bumper with Black Rub Strip.</span>
                            <span>Chrome Rear Bumper Insert.</span>
                            <span>Heated Folding Side-View Mirrors with Turn Signal Indicator.</span>
                            <span>Chrome Front Bumper Insert.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sport 4MATIC Sedans For Sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Lighting &amp; Instrumentation - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan Specials In Boerne, Texas</strong></span></h2>
                        <p><span>Available Delay-Off Project Beam LED Low Beam Headlamps.</span>
                            <span>Low-Fuel Warning.</span>
                            <span>Fully Automatic Headlights.</span>
                            <span>Bulb-Failure Warning.</span>
                            <span>Low-Coolant Warning.</span>
                            <span>Front Reading Lights.</span>
                            <span>Light-Tinted Windows.</span>
                            <span>Dome Light with Fade.</span>
                            <span>Variable Intermittent Rain Detecting Wipers with Heating Jets and Reservoir.</span>
                            <span>Outside Temperature Display.</span>
                            <span>Available Power Rear Window Blind.</span>
                            <span>Variable Intermittent Wipers.</span>
                            <span>Available Auto High-Beam Headlights.</span>
                            <span>Low-Oil-Level Warning.</span>
                            <span>Delay-Off Project Beam Halogen Headlamps.</span>
                            <span>Available Camera Rear.</span>
                            <span>Available Sun Blinds.</span>
                            <span>Water Temperature Gauge.</span>
                            <span>Delay-Off Headlights.</span>
                            <span>Available Rear Window Blind.</span>
                            <span>PRE-SAFE PLUS Rear Collision.</span>
                            <span>Front and Rear Reading Lights.</span>
                            <span>Rear Reading Lights.</span>
                            <span>Brake-Fluid Warning.</span>
                            <span>Rear Fog Lights.</span>
                            <span>Trip Computer.</span>
                            <span>Compass.</span>
                            <span>Available Directionally Adaptive Headlights.</span>
                            <span>Lights-On Warning.</span>
                            <span>Redundant Digital Speedometer.</span>
                            <span>Rear Window Defroster.</span>
                            <span>Light Tinted Windows.</span>
                            <span>4 Door Curb/Courtesy Lights.</span>
                            <span>Door-Ajar Warning.</span>
                            <span>Tire Pressure Sensors.</span>
                            <span>Heated Front Windshield Wiper Jets.</span>
                            <span>Available Cornering Lights.</span>
                            <span>Available Head-Up Display.</span>
                            <span>Available Blind Spot Sensor.</span>
                            <span>Systems Monitor.</span>
                            <span>Automated Reverse Sensing System.</span>
                            <span>Outside-Temperature Display.</span>
                            <span>Trunk Ajar Warning.</span>
                            <span>Available Analog Clock.</span>
                            <span>Available PARKTRONIC w/Active Parking Assist Automated Parking Sensors.</span>
                            <span>Available Camera - Rear.</span>
                            <span>Available Lane Departure.</span>
                            <span>Low-Washer-Fluid Warning.</span>
                            <span>Brake Pad Wear.</span>
                            <span>Variable Instrument Panel Lighting.</span>
                            <span>Trip Odometer.</span>
                            <span>Tachometer.</span>
                            <span>Available High Intensity Discharge Headlights.</span>
                            <span>In-Radio Display Clock.</span>
                            <span>Available Rear Side Blind.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sport 4MATIC Sedans For Sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Fine Art Meets State-Of-The-Art - 2015 Mercedes-Benz C300 Sport 4MATIC Sedan For Sale In Boerne, Texas</strong></span></h2>

                        <p><span>The 2015 Mercedes-Benz C300 Sport 4MATIC Sedan for sale in Boerne, Texas at Burns Motors takes its base model and enhances with a sleek, sporty look as well as Mercedes’ prestigious 4MATIC All-Wheel Drive system, adding power and capabilities that will get you where you want to go fast and in style. The used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan is one of the most popular models in its class. With plenty of luxury, amenities, and countless commodity and technology features, the used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan for sale in Boerne, Texas ensures there’s never a dull moment on the road. Visit us at Mark Motors in Boerne, Texas and let your team guide you through our extensive inventory and find the perfect used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan available for sale!</span><span>&nbsp;</span>
                            <span>Used 2015 Mercedes-Benz C300 Sport 4MATIC Sedan for sale in Boerne, Texas.</span><span>&nbsp;</span>
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            <span>See dealer or owner's literature for limited warranty details.</span>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Used2015MercedesBenzC300Sport4maticSedanForSaleInBoerneTexas